import { type Media } from "@common/declarations";
import { isNull } from "lodash";
import { type Accept } from "react-dropzone";

export const getAccept = (fileType: Media.Type | undefined): Accept | undefined => {
  switch (fileType) {
    case "Audio":
      return {
        "audio/*": []
      };
    case "Image":
      return {
        "image/*": []
      };
    case "Video": {
      return {
        "video/*": []
      };
    }
  }
};

export const getMaxSize = (maxSizeInMb: number | undefined | null): number | undefined =>
  isNull(maxSizeInMb) ? undefined : maxSizeInMb ?? 5;
export const getMaxSizeInBytes = (maxSizeInMb: number | undefined | null): number | undefined => {
  const maxSize = getMaxSize(maxSizeInMb);
  return maxSize ? maxSize * 1024 * 1024 : undefined;
};
